import { Controller } from 'stimulus';
import { triggerCustomEvent } from 'lib/helpers';

export default class EzModalController extends Controller {
  static targets = [
    'content',
  ]

  detectHeightCutoff = () => {
    if (this.contentTarget.parentNode.offsetHeight >= document.documentElement.clientHeight) {
      this.element.classList.add('is-too-tall');
    }
  }

  connect() {
    this.open();

    this.resetFocusOnModal();

    this.detectHeightCutoff();
  }

  open() {
    if (!document.body.classList.contains('has-active-modal')) {
      document.body.classList.add('has-active-modal');
    }
    this.element.classList.add('is-active');
  }

  close() {
    if (!this.element.hasAttribute('data-disable-easy-close')) {
      this.element.classList.remove('is-active');
      this.element.parentNode.removeChild(this.element);
      triggerCustomEvent('ModalClosed', {}, this.element);
    }

    if (!document.querySelector('.ez-modal') && document.body.classList.contains('has-active-modal')) {
      document.body.classList.remove('has-active-modal');
    }
  }

  resetFocusOnModal() {
    this.element.setAttribute('tabindex', -1);
    this.element.focus();
  }

  confirm(event) {
    this.close();
    triggerCustomEvent('ConfirmModalConfirm', {}, event.target);
  }

  deny() {
    this.close();
    return false;
  }
}
